<svg-icon (click)="cerrar.emit()" src="assets/imgs/comun/close.svg"></svg-icon>